module.exports = __webpack_public_path__ + "fonts/inter/inter-v20-latin-600italic.woff2";